import { createContext } from 'react';

export const OnboardingFooterHostContext = createContext<HTMLElement | null>(
  null,
);
